import { PublicTokenClient } from './PublicTokenClient';
import { UserTokenClient } from './UserTokenClient';
let userTokenClient;
let publicTokenClient;

/**
 * Gets token clients for this package, this keeps client instances to minimal
 */
export const getTokenClients = () => {
  userTokenClient ??= new UserTokenClient();
  publicTokenClient ??= new PublicTokenClient();
  return {
    userTokenClient,
    publicTokenClient
  };
};
//# sourceMappingURL=getTokenClients.js.map